import React, { useEffect } from 'react';
import { useLocation, useNavigate,useParams } from 'react-router-dom';
import Appbar from '../component/Appbar';
import { useDispatch, useSelector } from 'react-redux';
import Arrow from '../../../../assets/theme6/Arrow.svg';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Food from '../../../../assets/img/cat.png';
import { getSubCategoryAction } from '../../../../redux/screen/subcategory';
import Style from '../style/SubcategoryRewardMission.module.scss';
import Skeleton from '@mui/material/Skeleton';

const SubcategoryMission = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { subcategory_id } = useParams();
  const catname = location.state.catname
  const dispatch = useDispatch()
  const subcategory = useSelector(state => state.getSubcategory)
  const { data: subcategoryData, loading: subcategoryLoading, status, message } = subcategory
  const getAppSelector = useSelector(state => state.getApp)
  const { data: { is_ads_enabled } } = getAppSelector

  if (status === 401) {
    alert(message)
  }

  useEffect(() => {
    dispatch(getSubCategoryAction(subcategory_id))
  }, [dispatch])

  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });

  return (
    <>
      <Appbar />
      <div className={Style.main_div_sub}>
        <div className={Style.banner_sub}>
          <img style={{ marginTop: "10px" }} src={Food} />
          <p className={Style.subcategory_heading} style={{ fontWeight: "900" }}>{"this is the best"}</p>
        </div>
        <div className={Style.banner_sub_heading}>
          <p>{catname}</p>
        </div>
        <div className={Style.starting_text}>
          <p>Choose any of your favourite genre and get started.</p>
        </div>
        <div className={Style.categories_sec_sub}>
          {subcategoryLoading ? <>
            <Skeleton style={{ borderRadius: "10px" }} animation="wave" variant="rectangular" width={"48%"} height={170} />
            <Skeleton style={{ borderRadius: "10px" }} animation="wave" variant="rectangular" width={"48%"} height={170} />
            <Skeleton style={{ borderRadius: "10px" }} animation="wave" variant="rectangular" width={"48%"} height={170} />
            <Skeleton style={{ borderRadius: "10px" }} animation="wave" variant="rectangular" width={"48%"} height={170} />
          </> : subcategoryData?.length > 0 ? (subcategoryData.map((item, index) => {
            return (
              <>
                <div key={index} className={Style.categorie_sub} onClick={() => { navigate(`/mission/reward/${item._id}`)}}>
                  <div style={{ marginBottom: "30px" }}>
                    <div className={Style.heading_sub}>
                      {item.sub_cat_name}
                    </div>
                  </div>
                  <div className={Style.link_sub}>
                    <p>View Quizzes</p>
                    <span><img src={Arrow} alt='arrow' /></span>
                  </div>
                </div>
                {index % 2 !== 0 && is_ads_enabled && <div style={{ display: 'flex', width: "100vw", height: "20vh", alignItems: "center", justifyContent: "center", background: "#fff" }}>
                  ads
                </div>}
              </>
            )
          })) : (<span style={{ display: "flex", justifyContent: "center", alignItems: 'center', height: "80vh", width: "87vw", color: "#fff", }}>Subcategory Not Available</span>)}
        </div>
      </div>
    </>
  )
}

export default SubcategoryMission;
